import React from 'react';
import Icon from 'components/mweb/Icon/Icon';
import Drawer from 'components/common/Drawer';
import { connect } from 'react-redux';
import NotificationCard from '../../common/NotificationCard/NotificationCard';
import { postMarkAsReadNotifications } from 'hb-redux-store/feature/notifications/notifications.action';
import { convertArrayToObject } from 'hb-redux-store/util/miscellaneousServices';
import AnalyticsService from 'AnalyticsService';

const coinIcon =
  'https://ik.imagekit.io/iwcam3r8ka/prod/random/202012/9ca7c1aa-92aa-4270-b43a-6e23ccdfe999.svg';
// const featherIcon = 'https://ik.imagekit.io/iwcam3r8ka/prod/random/202012/9043ff4f-e948-4e04-97a4-cda920c62e9f.svg';
const featherIcon =
  'https://ik.imagekit.io/iwcam3r8ka/prod/random/202012/343a8c3a-2e1f-4e03-b840-00ed9367b51e.png';

const defaultNotif = {
  general: [
    {
      id: 1,
      icon: coinIcon,
      description:
        'Invite your friends to VegXL and earn Rs. 50 each with their first order. Refer & use your code.',
    },
    {
      id: 2,
      icon: featherIcon,
      description:
        'Thank you for the order. We value our customer review please write to us at link',
    },
  ],
};

const Notifications = props => {
  const { showNotifications, onShowNotifications } = props;
  const hasNotifications = props.notifications?.general?.length > 0;
  React.useEffect(() => {
    if (hasNotifications) {
      console.log('marking as read: ', props.notifications.general);
      props.postMarkAsReadNotifications({
        notificationList: props.notifications.general.map(n => ({
          ...n,
          isNoified: true,
        })),
      });

      // Clevertap Analytics
      const key = 'View Notification';
      AnalyticsService.clevertap.sendCleverTapEvent(key);
    }
  }, []);
  const onCancel = () => {
    onShowNotifications(false);
  };
  return (
    <Drawer
      title="NOTIFICATIONS"
      placement="right"
      closable={true}
      onClose={onCancel}
      visible={showNotifications}
      destroyOnClose={true}
      maskClosable={true}
      width={500}
      className="desktop-notifications"
    >
      <div className="desktop-notifications">
        {!hasNotifications && (
          <div className="desktop-notifications--empty">
            <Icon
              class="icon-empty-notifications desktop-notifications--illustration"
              width={180}
              height={133}
            />
            <div className="desktop-notifications--oops">Uh-Oh!</div>
            <div className="desktop-notifications--description">
              No noise yet!
            </div>
          </div>
        )}
        {hasNotifications && (
          <div className="desktop-notifications--general">
            {props.notifications?.general.map(n => {
              return (
                <NotificationCard
                  notification={n}
                  key={n.id}
                  onClick={onCancel}
                />
              );
            })}
          </div>
        )}
      </div>
    </Drawer>
  );
};

const mapStateToProps = ({ notificationReducer }) => ({
  notificationLoading: notificationReducer.notificationLoading,
  notifications: notificationReducer.notifications, // || defaultNotif,
});

const mapDispatchToProps = { postMarkAsReadNotifications };

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
